import { render, staticRenderFns } from "./modal-rule.vue?vue&type=template&id=3b543b5c&scoped=true"
import script from "./modal-rule.vue?vue&type=script&lang=js"
export * from "./modal-rule.vue?vue&type=script&lang=js"
import style0 from "./modal-rule.vue?vue&type=style&index=0&id=3b543b5c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b543b5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b543b5c')) {
      api.createRecord('3b543b5c', component.options)
    } else {
      api.reload('3b543b5c', component.options)
    }
    module.hot.accept("./modal-rule.vue?vue&type=template&id=3b543b5c&scoped=true", function () {
      api.rerender('3b543b5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/masters/rule/modal-rule.vue"
export default component.exports